/**
 * Constants for the One Pager Deal Summary editor.
 *
 * Header arrays drive both the column order and the per-row data lookup via
 * `*Display` field names produced by Polus Groovy transformations
 * (`transformOnePagerDirectorOverview`, `transformOnePagerBankingOverview`).
 */

export interface TableHeader {
    /** Field name on the BE-provided record (typically a pre-formatted display field). */
    key: string;
    /** Column heading shown in the One Pager / PDF. */
    label: string;
}

/**
 * Credit Bureau Summary — 7 columns.
 * Data source: `directorBureauList` (Polus → `transformOnePagerDirectorOverview`).
 */
export const CREDIT_BUREAU_HEADERS: ReadonlyArray<TableHeader> = [
    { key: 'nameDisplay', label: 'Name' },
    { key: 'dpdAccountsDisplay', label: 'DPD Accounts' },
    { key: 'currentOverdueDisplay', label: 'Overdue' },
    { key: 'maxDpdsDisplay', label: 'Max DPD (Days)' },
    { key: 'enquiriesInPast90DaysDisplay', label: 'Enquiries (90D)' },
    { key: 'cibilScoreDisplay', label: 'Bureau Score' },
    { key: 'creditBureauDisplay', label: 'Bureau' },
];

/**
 * Banking Summary — 7 columns.
 * Data source: `bankingOverviewList` (Polus → `transformOnePagerBankingOverview`).
 * The totals row is identified by `isTotalsRow: true` on the entry.
 */
export const BANKING_HEADERS: ReadonlyArray<TableHeader> = [
    { key: 'nameDisplay', label: 'Bank Name' },
    { key: 'accountNumberDisplay', label: 'Account No.' },
    { key: 'closingBalanceDisplay', label: 'Closing Balance' },
    { key: 'closingBalanceDateDisplay', label: 'Closing Balance Date' },
    { key: 'odSanctionLimitDisplay', label: 'OD/CC Sanction Limit' },
    { key: 'transactionsLTMDisplay', label: 'Transactions (LTM)' },
    { key: 'missingDaysDisplay', label: 'Missing Days (LTM)' },
];
